export default __webpack_public_path__ + "static/media/02AW1FEB66.538b1a4a.jpg";